import { Injectable } from '@angular/core';
import { DepartmentFood } from '@app/models/department-food';
import { DepartmentFoodService } from '@app/services/api/department-food.service';
import { FlashService } from '@app/services/flash.service';
import {
	DepartmentFoodActionTypes,
	LoadFail,
	LoadSuccess,
	LoadByConditions,
	LoadByConditionsSuccess,
	LoadByConditionsFail,
	Create,
	CreateSuccess,
	CreateFail,
	Search,
	SearchSuccess,
	SearchFail,
	Update,
	UpdateSuccess,
	UpdateFail,
	Delete,
	DeleteSuccess,
	DeleteFail,
	Void,
	LoadById,
	LoadByIdSuccess,
	LoadByIdFail
} from '@core/actions/department-food.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { concatMap, catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class DepartmentFoodEffects {
	@Effect()
	load$: Observable<Action> = this.actions$.pipe(
		ofType(DepartmentFoodActionTypes.Load),
		switchMap(() =>
			this.departmentsFoodApi.get().pipe(
				map((departments: DepartmentFood[]) => new LoadSuccess(departments)),
				catchError(error => of(new LoadFail(error)))
			)
		)
	);

	@Effect()
	loadByConditions: Observable<Action> = this.actions$.pipe(
		ofType<LoadByConditions>(DepartmentFoodActionTypes.LoadByConditions),
		map(action => [action.FollowId, action.dataConditions]),
		switchMap(([FollowId, dataConditions]) =>
			this.departmentsFoodApi.getByConditions(FollowId, dataConditions).pipe(
				map(
					(Departments: DepartmentFood[]) =>
						new LoadByConditionsSuccess(Departments)
				),
				catchError(error => of(new LoadByConditionsFail(error)))
			)
		)
	);

	@Effect()
	create$: Observable<Action> = this.actions$.pipe(
		ofType<Create>(DepartmentFoodActionTypes.Create),
		map(action => action.data),
		switchMap(data =>
			this.departmentsFoodApi.create(data).pipe(
				map((department: DepartmentFood) => new CreateSuccess(department)),
				catchError(error => of(new CreateFail(error)))
			)
		)
	);

	@Effect()
	createSuccess$: Observable<Action> = this.actions$.pipe(
		ofType<CreateSuccess>(DepartmentFoodActionTypes.CreateSuccess),
		map(action => {
			this.fs.emit({ type: 'success', message: 'JP creado con exito' });
			return new Void()
		})
	);
	@Effect()
	search$: Observable<Action> = this.actions$.pipe(
		ofType<Search>(DepartmentFoodActionTypes.Search),
		map(action => [action.data, action.FollowId]),
		switchMap(([data, FollowId]) =>
			this.departmentsFoodApi.search(data, FollowId).pipe(
				map(
					(countryDepartmentsIds: any[]) =>
						new SearchSuccess(countryDepartmentsIds)
				),
				catchError(error => of(new SearchFail(error)))
			)
		)
	);

	@Effect()
	update$: Observable<Action> = this.actions$.pipe(
		ofType<Update>(DepartmentFoodActionTypes.Update),
		map(action => [action.id, action.department]),
		concatMap(([id, department]) =>
			this.departmentsFoodApi.update(id, department).pipe(
				map((department: DepartmentFood) => { return new UpdateSuccess(id, department) }),
				catchError(error => of(new UpdateFail(error)))
			)
		)
	);

	@Effect()
	updateSuccess$: Observable<Action> = this.actions$.pipe(
		ofType<UpdateSuccess>(DepartmentFoodActionTypes.UpdateSuccess),
		map(action => {
			this.fs.emit({ type: 'success', message: 'JP actualizado con exito' });
			return new Void()
		})
	);

	@Effect()
	updateFail$ = this.actions$.pipe(
		ofType<UpdateFail>(DepartmentFoodActionTypes.UpdateFail),
		map(action => {
			this.fs.emit({ type: 'danger', message: 'Error al actualizar' });

			return new Void();
		})
	);



	@Effect()
	delete$: Observable<Action> = this.actions$.pipe(
		ofType<Delete>(DepartmentFoodActionTypes.Delete),
		map(action => action.id),
		concatMap(id =>
			this.departmentsFoodApi.destroySingle(id).pipe(
				concatMap(res => {
					this.fs.emit({
						type: 'success',
						message: 'JP eliminado exitosamente'
					});
					return [new DeleteSuccess(id)];
				}),
				catchError(error => of(new DeleteFail(error)))
			)
		)
	);

	@Effect()
	loadById$: Observable<Action> = this.actions$.pipe(
		ofType<LoadById>(DepartmentFoodActionTypes.LoadById),
		map(action => [action.FollowId, action.dataFilter]),
		switchMap(([FollowId, dataFilter]) =>
			this.departmentsFoodApi.getById(FollowId, dataFilter).pipe(
				map(
					(departments: DepartmentFood[]) =>
						new LoadByIdSuccess(departments[0].id, {
							quantity: departments[0].quantity,
							totalUs: departments[0].totalUs,
						})
				),
				catchError(error => of(new LoadByIdFail(error)))
			)
		)
	);



	@Effect()
	deleteFail$: Observable<Action> = this.actions$.pipe(
		ofType<DeleteFail>(DepartmentFoodActionTypes.DeleteFail),
		map(action => {
			// console.log(action)
			this.fs.emit({ type: 'danger', message: 'Error al eliminar' });
			return new Void()
		})
	);

	constructor(
		private actions$: Actions,
		private departmentsFoodApi: DepartmentFoodService,
		private fs: FlashService
	) { }
}
